export const footer = {
  sponsor: {
    coOrganize: 'Co-organizer',
    agency: 'Donor',
  },
}
